<template>
  <div class="nba-overlay-wrapper">
    <div class="nba-overlay-header">
      <p
        class="nba-overlay-header-label"
        :style="{ ...getFontSizeForResponse('title', false) }"
      >
        {{ getHeading }}
      </p>
      <button
        class="nba-overlay-close-btn"
        @click.stop="handleCrossButtonClicked()"
      >
        <div class="icon">
          <BaseIcon name="CloseIcon" />
        </div>
      </button>
    </div>
    <div class="nba-overlay-body">
      <div class="content-container">
        <NonActionableNBALink
          :linkData="getNonActionableNBALinks"
          :staticLinkData="getNbaStaticLinks"
        />
      </div>
    </div>
  </div>
</template>

<script>
import BaseIcon from '@/views/BaseIcon.vue'
import NonActionableNBALink from './NonActionableNBALink.vue'
import {constantStrings} from '@/services/constants'
import fontSizeMixin from '@/mixins/fontSizeMixin'

export default {
	name: 'NBAOverlay',
    components: {
        BaseIcon,
        NonActionableNBALink,
    },
    mixins: [fontSizeMixin],
    computed: {
        crossIcon() {
            return `${this.$cdn}/images/cross_dark.svg`
        },
        getNonActionableNBALinks() {
            return this.$store.state.nonActionableNBAOptions
        },
        getHeading() {
            return this.$store.state?.widgetConfig?.nbaConfig?.heading || constantStrings.ARTICLES_OFFERS
        },
        getNbaStaticLinks() {
            return this.$store.state?.widgetConfig?.nbaConfig?.staticLinks
        }
    }, 
    methods: {
        handleCrossButtonClicked() {
            this.$store.dispatch('updateNonActionableNBAOverlayEnabled', false)
        }
    }
}
</script>
<style lang="scss" scoped>

.nba-overlay-wrapper {
    display: flex;
    flex-direction: column;
    flex: 1;
    
    .nba-overlay-header {
        display: flex;
        padding: 12px 20px 12px 24px;
        align-items: center;
        gap: 8px;
        border-bottom: 1px solid #E8E8E8;
        border-radius: 8px 8px 0px 0px;

        .nba-overlay-header-label {
            font-weight: 500;
        }

        .nba-overlay-close-btn {
            margin-left: auto;
            border: none;
            cursor: pointer;
            background: none;
        }
    }

    .nba-overlay-body {
        display: flex;
        padding: 0 24px 24px;
        flex-direction: column;
        align-items: flex-start;
        gap: 24px;
        flex: 1 0 0;
        align-self: stretch; 
        height: 70%;
        margin-bottom: 20px;
        overflow: scroll;
        .content-container {
            width: 100%;
            .nba-overlay-content-label {
                color: #6D6D6D;
                font-weight: 600;
                line-height: 20px;
                margin-bottom: 10px;
            }
        }
    }
}
</style>
